import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../components/Button';

export const Wrapper = styled.div`
  width: 460px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  margin-top: -52px;
`;

export const Title = styled.h1`
  width: 100%;
  font-size: ${props => props?.theme.fonts.title['font-size']};
  font-weight: ${props => props?.theme.fonts.title['font-weight']};
  line-height: ${props => props?.theme.fonts.title['line-height']};
  text-align: center;
`;

export const Description = styled.p`
  font-size: ${props => props?.theme.fonts.label['font-size']};
  font-weight: ${props => props?.theme.fonts.label['font-weight']};
  line-height: ${props => props?.theme.fonts.label['line-height']};
  color: ${({ theme }) => theme.colors?.text?.secondary};
  margin-top: 20px;
  margin-bottom: 16px;
  text-align: ${({ textAlign }) => textAlign || 'center'};

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      text-align: left;
      margin-top: 15px;

      strong {
        font-size: 20px;
      }
    }
  }
`;

export const ForgetText = styled(NavLink)`
  width: 100%;
  text-align: right;
  padding: 0;
  margin: 0;
  font-size: ${props => props?.theme.fonts.label['font-size']};
  font-weight: ${props => props?.theme.fonts.label['font-weight']};
  line-height: ${props => props?.theme.fonts.label['line-height']};
  color: ${({ theme }) => theme.colors?.text?.secondary};
  margin-left: 60px;
  margin-top: -15px;
  text-decoration: none;
`;

export const SignupText = styled.p`
  width: 100%;
  text-align: center;
  padding: 0;
  margin: 0;
  font-size: ${props => props?.theme.fonts.label['font-size']};
  font-weight: ${props => props?.theme.fonts.label['font-weight']};
  line-height: ${props => props?.theme.fonts.label['line-height']};
  color: ${({ theme }) => theme.colors?.text?.secondary};
  margin-left: 60px;
  margin-top: 30px;

  & a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.accent.main};
  }
`;

export const Form = styled.form`
  margin-top: 38px;
  width: 93%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const FormButton = styled(Button)`
  width: 108%;
  margin-left: 8%;
  margin-top: 40px;
`;

export const UploadBox = styled.div`
  display: flex;
  flex-direction: row;
  margin: 60px 0 0 0;
  justify-content: flex-start;
  align-items: center;
  width: 600px;
  margin-left: -80px;
`;

export const UploadLabel = styled.label`
  width: 140px;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  cursor: pointer;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='gainsboro' stroke-width='5' stroke-dasharray='20' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");

  svg {
    font-size: 35px;
    color: ${({ theme }) => theme.colors.border.default};
  }

  p {
    width: 80%;
    font-size: ${props => props?.theme.fonts.label['font-size']};
    font-weight: ${props => props?.theme.fonts.label['font-weight']};
    line-height: 16px;
    color: ${({ theme }) => theme.colors?.border?.default};
    margin-top: 18px;

    span {
      color: ${({ theme }) => theme.colors?.accent.main};
    }
  }
`;

export const Separator = styled.div`
  font-size: ${props => props?.theme.fonts.text['font-size']};
  font-weight: ${props => props?.theme.fonts.text['font-weight']};
  color: ${({ theme }) => theme.colors?.border?.default};
  position: relative;
  margin: 0 38px;

  &::after {
    content: '';
    position: absolute;
    height: 56px;
    bottom: 105%;
    left: 7px;
    width: 1px;
    background: ${({ theme }) => theme.colors?.border?.default};
  }

  &::before {
    content: '';
    position: absolute;
    height: 56px;
    top: 105%;
    left: 7px;
    width: 1px;
    background: ${({ theme }) => theme.colors?.border?.default};
  }
`;

export const ColorBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  width: 220px;
  text-align: left;

  h3 {
    font-size: ${props => props?.theme.fonts.text['font-size']};
    font-weight: ${props => props?.theme.fonts.text['font-weight']};
    color: ${({ theme }) => theme.colors?.tab.main};
  }
`;

export const ColorPicker = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  margin-top: 21px;
  gap: 15px;
  flex-wrap: wrap;
`;

export const ColorPickerItem = styled.li`
  margin: 0;
  padding: 0;
  width: 20px;
  height: 20px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #fff;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
